import { render, staticRenderFns } from "./MyWalletClaimGasModal.vue?vue&type=template&id=4c385926"
import script from "./MyWalletClaimGasModal.vue?vue&type=script&lang=ts"
export * from "./MyWalletClaimGasModal.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletClaimGasModal.vue?vue&type=style&index=0&id=4c385926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports